import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-390d2232")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExampleBox = _resolveComponent("ExampleBox")

  return (_openBlock(), _createBlock(_component_ExampleBox, { class: "aspect-3-2 border-8 mb-2 demo" }))
})